import React from 'react';
import PropTypes from 'prop-types';
import './DashboardWidget.scss';
import ErrorBoundary from '../ErrorBoundary';

const DashboardWidget = ({ children, bgColor }) => {
    return (
        <ErrorBoundary errorPrefix="Error Loading Dashboard Widget" shouldSwallow={false}>
            <div className={`dashboard-widget bg-${bgColor}`}>
                <div className="dashboard-widget-body">
                    {children}
                </div>
            </div>
        </ErrorBoundary>
    );
};

DashboardWidget.propTypes = {
    bgColor: PropTypes.string.isRequired,
    children: PropTypes.node, // Use PropTypes.node for children validation
};

export default DashboardWidget;
